import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarFilterItem from '../VeltCommentsSidebarFilterItem/VeltCommentsSidebarFilterItem';
import VeltCommentsSidebarFilterName from '../VeltCommentsSidebarFilterName/VeltCommentsSidebarFilterName';
import VeltCommentsSidebarFilterSearch from '../VeltCommentsSidebarFilterSearch/VeltCommentsSidebarFilterSearch';
var VeltCommentsSidebarFilterCustom = function (props) {
    var children = props.children, id = props.id, remainingProps = __rest(props, ["children", "id"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-custom-wireframe", __assign({ id: id }, transformedProps), children));
};
VeltCommentsSidebarFilterCustom.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterCustom.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterCustom.Search = VeltCommentsSidebarFilterSearch;
export default VeltCommentsSidebarFilterCustom;
